import React, { memo, useEffect, useState } from "react";
import { ReactComponent as LogoIcon } from "../../images/logo.svg";
import { BatteryStatus, ContractsAndJudicialDocumentsTypes, RootCategoriesTypes } from "../../constant/Types";
import { LoadingOutlined, LeftOutlined, UpOutlined } from "@ant-design/icons";
import { convertNumToFa, convertSecondToTime } from "../../constant/helper";
import AvatarPreview from "../../pages/profile/components/AvatarPreview";
import { Link } from "react-router-dom";
import "../../styles/components/BatteyComponent.style.scss";

const Battery = ({
  loading,
  info,
  lawyerInfo,
  showLawyerInfo,
  isOpen,
  setIsOpen,
  clientInfo,
  toggleLawyerInfo = () => {},
  sessionDetail,
  avatar,
  openExteraInfo,
}) => {
  const [status, setStatus] = useState(BatteryStatus.dead);

  useEffect(() => {
    handleChangeStatus();
    // eslint-disable-next-line
  }, [info]);

  function handleChangeStatus() {
    if (!info && !loading) {
      setStatus(BatteryStatus.dead);
      return false;
    }
    const { battery } = info;
    if (
      !battery ||
      isNaN(battery) ||
      battery === "0" ||
      battery < 0 ||
      battery === 0
    ) {
      setStatus(BatteryStatus.dead);
    } else if (battery <= 25) {
      setStatus(BatteryStatus.nope);
    } else if (battery > 25 && battery <= 50) {
      setStatus(BatteryStatus.low);
    } else if (battery > 50 && battery <= 75) {
      setStatus(BatteryStatus.mid);
    } else if (
      (battery > 75 && battery <= 100) ||
      battery === "infinite" ||
      battery > 100
    ) {
      setStatus(BatteryStatus.high);
    }
  }

  if (loading) {
    return (
      <>
        <LogoIcon className={"logo"} />
        <div className={"battery-place"}>
          <LoadingOutlined />
        </div>
      </>
    );
  }

  const backBtn = (
    <div className="back-btn">
      <Link to={"/home"}>
        <LeftOutlined style={{ color: "#ffffff" }} />
      </Link>
    </div>
  );

  const stringSpliter = (text) => {
    const chars = 50;
    const splited = text.split("");
    if (splited.length > chars) {
      const split2 = splited.slice(0, chars);
      split2.push("...");
      return split2.join("");
    }
    return text;
  };

  return (
    <div className="battry-component-wrapper">
      <div>
        <div
          onClick={() => {
            openExteraInfo();
          }}
          className="battery-logo"
        >
          <AvatarPreview src={avatar} className={"avatar"} />
        </div>
        <div className="title-battery">
          {stringSpliter(
            `${
              sessionDetail && sessionDetail.type
                ? {...RootCategoriesTypes, ...ContractsAndJudicialDocumentsTypes}[sessionDetail.type].value
                : "---"
            }${
              !!sessionDetail.categoryName
                ? `(${sessionDetail.categoryName})`
                : ""
            }`
          )}
        </div>
        <div>
          <div
            className={`battery-place`}
            onClick={() => {
              if (sessionDetail.type !== "advocacy_acceptation") {
                setIsOpen(!isOpen);
              }
            }}
          >
            <div
              className={`battery-shape ${
                sessionDetail.type === "advocacy_acceptation"
                  ? BatteryStatus.high
                  : status
              }`}
            />
          </div>
        </div>
      </div>
      <div
        className={`battery-wrapper ${isOpen && `active`} ${
          info.timeBase ? "timebase-battery" : "not-timebase-battery"
        }`}
        onClick={() => {
          setIsOpen(!isOpen);
        }}
      >
        {info.timeBased ? (
          <>
            <div className="center-flex battery-detail-header">
              <span>صورت حساب لحظه ای</span>
              {backBtn}
            </div>
            <div className="mt-4 center-flex chat-live-status">
              <span className="title">
                <strong>زمان کل پکیج:</strong>
              </span>
              <span className="text">
                <b>
                  {info.totalSessionTimeInSeconds !== undefined &&
                    convertNumToFa(
                      convertSecondToTime(info.totalSessionTimeInSeconds) || "0"
                    )}
                </b>
              </span>
            </div>
            <div className="mt-4 center-flex chat-live-status">
              <span className="title">
                <strong>زمان باقیمانده پکیج:</strong>
              </span>
              <span className="text">
                <b>
                  {info.totalRemainingTimeInSeconds !== undefined &&
                    convertNumToFa(
                      convertSecondToTime(info.totalRemainingTimeInSeconds) ||
                        "0"
                    )}
                </b>
              </span>
            </div>
          </>
        ) : (
          <>
            <div className="center-flex battery-detail-header">
              <span>صورت حساب لحظه ای</span>
              {backBtn}
            </div>
            <div className="mt-4 center-flex chat-live-status">
              <span className="title">
                <strong>زمان مجاز ارسال وویس:</strong>
              </span>
              <span className="text">
                <b>
                  {info.totalRemainingTimeInSeconds !== undefined &&
                    convertNumToFa(
                      convertSecondToTime(info.totalRemainingTimeInSeconds) ||
                        "0"
                    )}
                </b>
              </span>
            </div>
            <div className="mt-3 center-flex chat-live-status">
              <span className="title">
                <strong>معادل تعداد کاراکتر مجاز تایپ:</strong>
              </span>
              <span className="text">
                <b>
                  {convertNumToFa(
                    (info.remainingCharacters || 0).toLocaleString("fa")
                  )}
                </b>
                <b>کاراکتر</b>
              </span>
            </div>
            <div className="mt-3 center-flex chat-live-status">
              <span className="title">
                <strong>معادل تعداد صفحه مجاز آپلود:</strong>
              </span>
              <span className="text">
                <b>
                  {convertNumToFa(
                    (info.remainingDocumentPages || 0).toLocaleString("fa")
                  )}
                </b>
                <b>صفحه</b>
              </span>
            </div>
            <div className="mt-3 center-flex chat-live-status">
              <span className="title">
                <strong>تعداد صفحه رایگان آپلود:</strong>
              </span>
              <span className="text">
                <b>
                  {convertNumToFa(
                    (info.freeDocumentPages || 0).toLocaleString("fa")
                  )}
                </b>
                <b>صفحه</b>
              </span>
            </div>
            {clientInfo && (
              <div className="lawyer-avatar-wrapper">
                <AvatarPreview
                  isSvg={false}
                  src={
                    (clientInfo &&
                      clientInfo?.extraInfo &&
                      clientInfo?.extraInfo?.avatarImageUrl) ||
                    5
                  }
                  onClick={toggleLawyerInfo}
                />
              </div>
            )}
          </>
        )}
        <UpOutlined className={"close-btn"} onClick={() => setIsOpen(false)} />
      </div>
    </div>
  );
};

export default memo(Battery);
